import React from "react";
import "./ContactUsMap.css";

const ContactUsMap = () => {
  return (
    <div className="contact-map-container">
      <iframe
        title="BA Code Solutions Location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3672.0586981873453!2d72.5908577!3d23.021616899999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e85b54840afa3%3A0x7046a97058e5caa5!2sSONI%20JEWELLERS!5e0!3m2!1sen!2sin!4v1767696427170!5m2!1sen!2sin"
        width="100%"
        className="contact-map-iframe"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
};

export default ContactUsMap;
